import { Controller } from "@hotwired/stimulus"

// Universal dropdown controller that works reliably with Turbo
export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    this.boundCloseOnEsc = this.closeOnEsc.bind(this)
  }

  disconnect() {
    this.removeGlobalListeners()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Close any other open dropdowns first
    document.querySelectorAll('[data-controller="dropdown"]').forEach(el => {
      if (el !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(el, 'dropdown')
        if (controller && controller.isOpen) {
          controller.close()
        }
      }
    })

    this.menuTarget.classList.add('show')
    this.buttonTarget.setAttribute('aria-expanded', 'true')
    this.addGlobalListeners()
  }

  close() {
    this.menuTarget.classList.remove('show')
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.removeGlobalListeners()
  }

  get isOpen() {
    return this.menuTarget.classList.contains('show')
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEsc(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  addGlobalListeners() {
    document.addEventListener('click', this.boundCloseOnClickOutside)
    document.addEventListener('keydown', this.boundCloseOnEsc)
  }

  removeGlobalListeners() {
    document.removeEventListener('click', this.boundCloseOnClickOutside)
    document.removeEventListener('keydown', this.boundCloseOnEsc)
  }
}
